import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:8088/kcauth/',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'avantech',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'avantech',
});

// Function to set up token expiration listeners
export const setupTokenExpirationHandler = (onTokenExpired) => {
  // Check if token is expired or about to expire every second
  setInterval(() => {
    if (keycloak.isTokenExpired()) {
      if (onTokenExpired) {
        onTokenExpired();
      }
    }
  }, 1000);

  // Also listen for token expiration event
  keycloak.onTokenExpired = () => {
    if (onTokenExpired) {
      onTokenExpired();
    }
  };

  // Listen for auth refresh errors
  keycloak.onAuthRefreshError = () => {
    if (onTokenExpired) {
      onTokenExpired();
    }
  };
};

export default keycloak;